export const getProjectSpecialNotes = (state) => {
  return state.pages.projectView.project.specialNotes;
};
